export const getUsersUrl = (page, q) => {
  let url = '/users';
  let op = '?';

  if (page) {
    url = url.concat(`?page=${page}`);
    op = '&';
  }
  if (q) url = url.concat(`${op}q=${q}`);

  return url;
};

export const displayLabel = text => {
  return `${text}*`;
};

export const getFormattedPayload = payload =>
  Object.keys(payload).reduce((acc, filterKey) => {
    const selectedValue = payload[filterKey];
    if (selectedValue.length) {
      const transformedValue = selectedValue.map(item => item.value);
      return { ...acc, [filterKey]: transformedValue };
    }
    return { ...acc, [filterKey]: selectedValue };
  }, {});

export const isFilterApplied = filters =>
  Object.keys(filters).some(filter => !!filters[filter].length);

export const initialFiltersValue = {
  salesManager: '',
  channel: '',
  dealership: '',
  outletId: '',
  channelOrgCode: '',
  accountStatus: ''
};
